import {
  ArrowUUpLeftIcon,
  BuildingsIcon,
  ClockCountdownIcon,
  ClockIcon,
  EnvelopeOpenIcon,
  MapPinIcon,
  StairsIcon,
  UserSoundIcon,
  UsersIcon,
} from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { EMPTY_VALUE } from '@/constants'
import { CommunicationTypeEnum } from '@/models'

import {
  type AnnouncementDetailsPanelData,
  type AnnouncementField,
} from './announcement-details-panel.types'

export const getAnnouncementDetailsPanelFields = (
  data: AnnouncementDetailsPanelData,
  t: TFunction<['communication']>,
): AnnouncementField[] => {
  const isEmail = data.type === CommunicationTypeEnum.enum.Email
  const isSms = data.type === CommunicationTypeEnum.enum.SMS

  const result: AnnouncementField[] = []

  result.push({
    icon: UsersIcon,
    label: t('communication:announcementDetails.panel.fields.recipients'),
    value: data.recipients,
  })
  if (data.phase)
    result.push({
      icon: MapPinIcon,
      label: t('communication:announcementDetails.panel.fields.phase'),
      value: data.phase,
    })
  if (data.buildingNumber)
    result.push({
      icon: BuildingsIcon,
      label: t('communication:announcementDetails.panel.fields.building'),
      value: data.buildingNumber,
    })
  if (data.floors)
    result.push({
      icon: StairsIcon,
      label: t('communication:announcementDetails.panel.fields.floors'),
      value: data.floors,
    })
  if (!isSms)
    result.push({
      icon: EnvelopeOpenIcon,
      label: t('communication:announcementDetails.panel.fields.mailingList'),
      value: data.mailingList,
    })
  if (isEmail)
    result.push({
      icon: ArrowUUpLeftIcon,
      label: t('communication:announcementDetails.panel.fields.replyTo'),
      value: data.replyTo || EMPTY_VALUE,
    })
  if (isEmail)
    result.push({
      icon: UserSoundIcon,
      label: t('communication:announcementDetails.panel.fields.from'),
      value: data.from || EMPTY_VALUE,
    })
  if (data.timeSent)
    result.push({
      icon: ClockCountdownIcon,
      label: t('communication:announcementDetails.panel.fields.timeSent'),
      value: data.timeSent,
    })
  if (data.timeScheduled)
    result.push({
      icon: ClockIcon,
      label: t('communication:announcementDetails.panel.fields.timeScheduled'),
      value: data.timeScheduled,
    })

  return result
}
